// VNEC v9 — pages/dashboard.js
// Layout mới: KPI grid → Kho/Prepaid → 2 cột [Việc cần xử lý | Hoạt động gần đây]
import { supabase, rpc } from '../lib/supabase.js';
import { formatVND, thisMonthISO, esc } from '../lib/forms.js';
import { err } from '../components/toast.js';

let _state = { feedOffset: 0, feedFilter: 'all', feedAll: [] };

export async function renderDashboard() {
  window.__pageInit = init;
  return `
    <div class="page">
      <div class="page-header">
        <h1>Tổng quan</h1>
        <p class="muted small">Cập nhật: ${new Date().toLocaleString('vi-VN')}</p>
      </div>
      <div class="kpi-grid" id="kpi-grid">
        ${sk('Hợp đồng đã duyệt')} ${sk('Chi phí tháng này')}
        ${sk('PYC chờ duyệt')} ${sk('Dự án đang hoạt động')}
      </div>
      <div class="grid-2-col">
        <div class="card">
          <h3>Kho vật tư</h3>
          <div id="kho-summary"><p class="muted">Đang tải...</p></div>
        </div>
        <div class="card">
          <h3>CP Chờ Phân Bổ (Prepaid)</h3>
          <div id="prepaid-summary"><p class="muted">Đang tải...</p></div>
        </div>
      </div>

      <div class="dash-feed-grid">
        <div class="card dash-pending-card">
          <div class="dash-card-hd">
            <h3>Việc cần tôi xử lý</h3>
            <span class="muted small" id="pending-count">—</span>
          </div>
          <div id="pending-list"><p class="muted">Đang tải...</p></div>
        </div>

        <div class="card dash-feed-card">
          <div class="dash-card-hd">
            <h3>Hoạt động gần đây</h3>
            <div class="dash-chips" id="feed-chips">
              <button class="dash-chip on" data-f="all">Tất cả</button>
              <button class="dash-chip" data-f="business">Nghiệp vụ</button>
              <button class="dash-chip" data-f="admin">Quản trị</button>
              <button class="dash-chip" data-f="me">Của tôi</button>
            </div>
          </div>
          <div id="feed-list"><p class="muted">Đang tải...</p></div>
          <div class="dash-feed-more">
            <button class="btn btn-ghost btn-sm" id="feed-more" style="display:none">Xem thêm</button>
          </div>
        </div>
      </div>
    </div>`;
}

function sk(label) {
  return `<div class="kpi-card"><div class="kpi-label">${label}</div><div class="kpi-value skeleton">—</div></div>`;
}

async function init() {
  await Promise.all([loadStats(), loadPending(), loadFeed(true)]);

  document.querySelectorAll('#feed-chips .dash-chip').forEach(c => {
    c.addEventListener('click', () => {
      document.querySelectorAll('#feed-chips .dash-chip').forEach(x => x.classList.remove('on'));
      c.classList.add('on');
      _state.feedFilter = c.dataset.f;
      _state.feedOffset = 0;
      _state.feedAll = [];
      loadFeed(true);
    });
  });

  document.getElementById('feed-more').addEventListener('click', () => loadFeed(false));
}

// ════════════════════════════════════════════════════════════
// KPI + Kho + Prepaid
// ════════════════════════════════════════════════════════════
async function loadStats() {
  const grid = document.getElementById('kpi-grid');
  try {
    const thisMonth = thisMonthISO();
    const [hd, cp, pyc, da, inv, pre] = await Promise.all([
      supabase.from('hop_dong').select('id', { count: 'exact', head: true }).eq('trang_thai', 'approved').is('deleted_at', null),
      supabase.from('chi_phi').select('thanh_tien').eq('trang_thai', 'approved').gte('ngay_ct', thisMonth + '-01').is('deleted_at', null),
      supabase.from('pyctt').select('id', { count: 'exact', head: true }).in('trang_thai', ['pending_l1','pending_l2']).is('deleted_at', null),
      supabase.from('du_an').select('id', { count: 'exact', head: true }).eq('trang_thai', 'active').is('deleted_at', null),
      supabase.from('ton_kho').select('gia_tri_ton'),
      supabase.from('prepaid_allocation').select('gia_tri_pb')
    ]);

    const cpSum  = (cp.data  || []).reduce((s, r) => s + Number(r.thanh_tien || 0), 0);
    const invSum = (inv.data || []).reduce((s, r) => s + Number(r.gia_tri_ton || 0), 0);
    const preSum = (pre.data || []).reduce((s, r) => s + Number(r.gia_tri_pb  || 0), 0);

    grid.innerHTML = `
      ${kpi('Hợp đồng đã duyệt', hd.count || 0)}
      ${kpi('Chi phí tháng này', formatVND(cpSum) + ' đ')}
      ${kpi('PYC chờ duyệt', pyc.count || 0, (pyc.count||0) > 0 ? 'warning' : '')}
      ${kpi('Dự án đang hoạt động', da.count || 0)}`;

    document.getElementById('kho-summary').innerHTML = `
      <div class="mini-stat"><span>Tồn kho hiện tại:</span> <strong>${formatVND(invSum)} đ</strong></div>
      <a href="#/kho" class="btn btn-ghost btn-sm">Xem chi tiết →</a>`;

    document.getElementById('prepaid-summary').innerHTML = `
      <div class="mini-stat"><span>CP chờ phân bổ:</span> <strong>${formatVND(preSum)} đ</strong></div>
      <a href="#/prepaid" class="btn btn-ghost btn-sm">Xem chi tiết →</a>`;
  } catch (e) {
    err('Lỗi tải dữ liệu: ' + e.message);
    grid.innerHTML = '<p class="muted">Không thể tải dữ liệu.</p>';
  }
}

function kpi(label, value, variant = '') {
  return `<div class="kpi-card ${variant}"><div class="kpi-label">${label}</div><div class="kpi-value">${value}</div></div>`;
}

// ════════════════════════════════════════════════════════════
// Widget 1: Việc cần tôi xử lý
// ════════════════════════════════════════════════════════════
async function loadPending() {
  const el = document.getElementById('pending-list');
  const cntEl = document.getElementById('pending-count');
  try {
    const data = await rpc('get_my_pending_actions');
    const items = (data || []).sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    cntEl.textContent = items.length === 0 ? 'Không có' : `${items.length} mục`;

    if (!items.length) {
      el.innerHTML = '<p class="muted center" style="padding:1rem 0">🎉 Không có việc nào cần xử lý.</p>';
      return;
    }

    const top = items.slice(0, 5);
    let html = '';
    top.forEach(it => {
      const isReopen = it.action_kind === 'reopen_rejected';
      const isL1 = it.action_kind === 'approve_l1';
      const badgeCls = isReopen ? 'badge-reject' : 'badge-pending';
      const badgeText = isReopen ? 'Bị từ chối' : (isL1 ? 'Chờ L1' : 'Chờ L2');
      const tableLabel = TABLE_VN[it.table_name] || it.table_name;
      const subText = isReopen
        ? (it.sub_label ? `Lý do: ${esc(it.sub_label)}` : 'Hồ sơ bị từ chối')
        : `${esc(it.sub_label || '')} · ${formatVND(it.amount || 0)} đ`;
      const btnText = isReopen ? 'Mở lại' : (isL1 ? 'Duyệt L1' : 'Duyệt L2');
      const rejBadge = it.rejection_count > 0 ? `<span class="dash-mini-badge">×${it.rejection_count}</span>` : '';

      html += `
        <div class="dash-pending-row" data-table="${it.table_name}" data-id="${it.record_id}">
          <span class="dash-badge ${badgeCls}">${badgeText}</span>
          <div class="dash-row-body">
            <div class="dash-row-l1">${tableLabel} — <strong>${esc(it.label || '')}</strong>${rejBadge}</div>
            <div class="dash-row-l2">${subText}</div>
          </div>
          <button class="btn btn-primary btn-sm dash-pending-btn">${btnText}</button>
        </div>`;
    });

    if (items.length > 5) {
      html += `<div class="dash-feed-more"><a href="#/approvals" class="btn btn-ghost btn-sm">Xem tất cả ${items.length} mục →</a></div>`;
    }
    el.innerHTML = html;

    el.querySelectorAll('.dash-pending-row').forEach(row => {
      row.addEventListener('click', () => { window.location.hash = '#/approvals'; });
    });
  } catch (e) {
    el.innerHTML = `<p class="muted">Lỗi: ${esc(e.message)}</p>`;
  }
}

// ════════════════════════════════════════════════════════════
// Widget 2: Hoạt động gần đây
// ════════════════════════════════════════════════════════════
const PAGE_SIZE = 20;

async function loadFeed(reset) {
  const el = document.getElementById('feed-list');
  const moreBtn = document.getElementById('feed-more');
  if (reset) {
    el.innerHTML = '<p class="muted">Đang tải...</p>';
    _state.feedOffset = 0;
    _state.feedAll = [];
  }
  try {
    const data = await rpc('get_dashboard_feed', {
      p_limit: PAGE_SIZE,
      p_offset: _state.feedOffset,
      p_filter: _state.feedFilter
    });
    _state.feedAll = _state.feedAll.concat(data || []);
    _state.feedOffset += PAGE_SIZE;

    if (!_state.feedAll.length) {
      el.innerHTML = '<p class="muted center" style="padding:1rem 0">Không có hoạt động nào.</p>';
      moreBtn.style.display = 'none';
      return;
    }

    el.innerHTML = renderFeed(_state.feedAll);
    moreBtn.style.display = (data && data.length === PAGE_SIZE) ? '' : 'none';

    el.querySelectorAll('.dash-feed-row[data-table]').forEach(row => {
      row.addEventListener('click', () => {
        const tbl = row.dataset.table;
        const path = ROUTE_BY_TABLE[tbl];
        if (path) window.location.hash = path;
      });
    });
  } catch (e) {
    el.innerHTML = `<p class="muted">Lỗi: ${esc(e.message)}</p>`;
  }
}

function renderFeed(items) {
  const groups = new Map();
  items.forEach(it => {
    const key = dayKey(it.created_at);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(it);
  });

  let html = '';
  for (const [dayLabel, rows] of groups.entries()) {
    html += `<div class="dash-day-hd">${dayLabel}</div>`;
    rows.forEach(it => {
      const ab = ACTION_BADGES[it.action] || { label: it.action, cls: 'badge-other' };
      const tableLabel = TABLE_VN[it.table_name] || it.table_name || '';
      const userName = it.user_name || it.user_email || 'Hệ thống';
      const groupBadge = it.group_count > 1 ? `<span class="dash-mini-badge">×${it.group_count}</span>` : '';
      const sub = it.sub_label ? `${esc(userName)} · ${esc(it.sub_label)}` : esc(userName);
      const isClickable = ROUTE_BY_TABLE[it.table_name] ? `data-table="${it.table_name}"` : '';

      html += `
        <div class="dash-feed-row" ${isClickable}>
          <span class="dash-badge ${ab.cls}">${ab.label}</span>
          <div class="dash-row-body">
            <div class="dash-row-l1">${tableLabel} — <strong>${esc(it.label || '')}</strong>${groupBadge}</div>
            <div class="dash-row-l2">${sub}</div>
          </div>
          <span class="dash-row-time">${relTime(it.created_at)}</span>
        </div>`;
    });
  }
  return html;
}

// ════════════════════════════════════════════════════════════
// Helpers
// ════════════════════════════════════════════════════════════
const TABLE_VN = {
  hop_dong:      'Hợp đồng',
  plhd:          'Phụ lục HĐ',
  don_hang:      'Đơn hàng',
  chi_phi:       'Chi phí',
  pyctt:         'Phiếu YCTT',
  kho_giao_dich: 'Giao dịch kho',
  ton_kho:       'Tồn kho',
  du_an:         'Dự án',
  user_profiles: 'Tài khoản',
  ngan_sach:     'Ngân sách',
  doanh_so:      'Doanh số',
  ghi_nhan_cp:   'Trích trước'
};

const ROUTE_BY_TABLE = {
  hop_dong: '#/hop-dong',
  plhd:     '#/phu-luc',
  don_hang: '#/don-hang',
  chi_phi:  '#/chi-phi',
  pyctt:    '#/pyctt',
  du_an:    '#/du-an',
  ngan_sach:'#/ngan-sach',
  doanh_so: '#/doanh-so'
};

const ACTION_BADGES = {
  SUBMIT:               { label: 'Nộp duyệt', cls: 'badge-submit' },
  APPROVE_L1:           { label: 'Duyệt L1',  cls: 'badge-approve' },
  APPROVE_L2:           { label: 'Duyệt L2',  cls: 'badge-approve' },
  REJECT:               { label: 'Từ chối',   cls: 'badge-reject' },
  REOPEN:               { label: 'Mở lại',    cls: 'badge-other' },
  CREATE:               { label: 'Tạo mới',   cls: 'badge-other' },
  UPDATE:               { label: 'Cập nhật',  cls: 'badge-other' },
  DELETE:               { label: 'Xóa',       cls: 'badge-reject' },
  RESTORE:              { label: 'Khôi phục', cls: 'badge-approve' },
  XUAT_KHO:             { label: 'Xuất kho',  cls: 'badge-kho' },
  ADMIN_CREATE_USER:    { label: 'Tạo user',  cls: 'badge-admin' },
  ADMIN_UPDATE_USER:    { label: 'Sửa user',  cls: 'badge-admin' },
  ADMIN_DELETE_USER:    { label: 'Xóa user',  cls: 'badge-admin' },
  ADMIN_GRANT_PROJECT:  { label: 'Cấp DA',    cls: 'badge-admin' },
  ADMIN_REVOKE_PROJECT: { label: 'Thu DA',    cls: 'badge-admin' },
  ADMIN_SOFT_DELETE:    { label: 'Xóa mềm',   cls: 'badge-admin' },
  ADMIN_HARD_DELETE:    { label: 'Xóa cứng',  cls: 'badge-admin' },
  ADMIN_RESTORE:        { label: 'Khôi phục', cls: 'badge-admin' }
};

function relTime(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const now = new Date();
  const diffMs = now - d;
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 1) return 'Vừa xong';
  if (diffMin < 60) return `${diffMin} phút trước`;
  if (d.getDate() === now.getDate() && d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear()) {
    return d.toLocaleTimeString('vi-VN', { hour: '2-digit', minute: '2-digit' });
  }
  const yest = new Date(now); yest.setDate(yest.getDate() - 1);
  if (d.getDate() === yest.getDate() && d.getMonth() === yest.getMonth() && d.getFullYear() === yest.getFullYear()) {
    return d.toLocaleTimeString('vi-VN', { hour: '2-digit', minute: '2-digit' });
  }
  return d.toLocaleDateString('vi-VN', { day: '2-digit', month: '2-digit' }) + ' ' +
         d.toLocaleTimeString('vi-VN', { hour: '2-digit', minute: '2-digit' });
}

function dayKey(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const now = new Date();
  if (d.getDate() === now.getDate() && d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear()) return 'Hôm nay';
  const yest = new Date(now); yest.setDate(yest.getDate() - 1);
  if (d.getDate() === yest.getDate() && d.getMonth() === yest.getMonth() && d.getFullYear() === yest.getFullYear()) return 'Hôm qua';
  return d.toLocaleDateString('vi-VN', { weekday: 'long', day: '2-digit', month: '2-digit' });
}
